import { render, staticRenderFns } from "./ModalSyncZalora.vue?vue&type=template&id=228b7099&scoped=true&"
import script from "./ModalSyncZalora.vue?vue&type=script&lang=js&"
export * from "./ModalSyncZalora.vue?vue&type=script&lang=js&"
import style0 from "./ModalSyncZalora.vue?vue&type=style&index=0&id=228b7099&prod&lang=scss&"
import style1 from "./ModalSyncZalora.vue?vue&type=style&index=1&id=228b7099&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228b7099",
  null
  
)

export default component.exports